import { FC, ReactNode } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import { TextArea } from 'dibs-elements/exports/TextArea';

import { PRIVATE_ADVISOR_ASSISTANCE, FormData } from '../reducer';

import styles from './styles/IFramedPromoPartnershipPCForm.scss';

type PrivateAdvisorAssistanceField = typeof PRIVATE_ADVISOR_ASSISTANCE;
type PrivateAdvisorAssistanceValue = FormData[PrivateAdvisorAssistanceField];

type Props = {
    value: PrivateAdvisorAssistanceValue;
    errorMessage: ReactNode;
    disabled?: boolean;
    setField: (field: PrivateAdvisorAssistanceField, value: PrivateAdvisorAssistanceValue) => void;
};

const PrivateAdvisorAssistanceTextArea: FC<Props> = ({
    value,
    errorMessage,
    disabled,
    setField,
}) => {
    return (
        <div className={styles.field}>
            <TextArea
                dataTn="promo-partnership-private-advisor-assistance-text-area"
                name="promo-partnership-private-advisor-assistance"
                label={
                    <FormattedMessage
                        id="iFramedpromoPartnership.PrivateAdvisorAssistanceTextArea.label"
                        defaultMessage="How can our Private Client Advisors help?"
                    />
                }
                value={value}
                onChange={e => setField(PRIVATE_ADVISOR_ASSISTANCE, e.target.value)}
                rows={3}
                errorMessage={errorMessage}
                disabled={disabled}
            />
        </div>
    );
};

export default PrivateAdvisorAssistanceTextArea;
